module.exports = __webpack_public_path__ + "static/media/pdm_process.a71bb8a7.png";